
import { Box, styled } from "@mui/material";

export const HeaderConatiner = styled(Box)(({ theme }) => ({
  position: "relative",
  zIndex: "2",
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: "none !important",
  background: "transparent",
  padding: "1.5rem 0.8rem 1rem !important",
  maxWidth: "1440px",
  margin: "0 auto",
  paddingLeft: "1rem",
  paddingRight: "1rem",
  "@media (max-width:768px)":{
    padding:"0.2rem 0.2rem !important"
  }
}));

export const AppBar = styled("div")(({ theme }) => ({
  backgroundColor: "transparent",
  boxShadow: "none",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(1.5, 7.5),

  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2.9, 3),
  },
}));

export const ImmutiverseLogo = styled("img")(({ menuOpen }) => ({
  flexShrink: 0,
  width: "auto",
  maxWidth: "300px",
  height: "100%",
  maxHeight: "clamp(20px, 5vw, 34px)",
  transition: "all 0.3s ease-in-out",
  zIndex: 3001,

  "@media (max-width: 900px)": {
    position: menuOpen ? "fixed" : "relative",
    top: menuOpen ? "1.5rem" : "auto",
    left: menuOpen ? "1.5rem" : "auto",
    maxHeight: menuOpen ? "30px" : "30px",
  },
  "@media (max-width: 480px)": {
    maxHeight: "26px", 
    maxWidth: "180px",
  },
}));


export const HeaderLeft = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "2rem",
});

export const NavigationLinks = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "2rem !important",
  "@media (max-width: 768px)": {
    display: "none",
  },
});

export const NavLink = styled("a")({
  color: "#fff",
  textDecoration: "none",
  fontSize: "1rem",
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontWeight: "400",
  transition: "color 0.3s ease",
  "&:hover": {
    color: "#4CAF50",
  },
});


export const DropdownContainer = styled("div")({
  position: "relative",
  display: "inline-block",
});

export const DropdownMenu = styled("div")(({ open }) => ({
  display: open ? "block" : "none",
  position: "absolute",
  top: "100%",
  left: 0,
  backgroundColor: "transparent",
  minWidth: "180px",
  zIndex: 2000,
  paddingTop: "2px",
  paddingBottom: "2px",
}));

export const DropdownItem = styled("a")(({ active }) => ({
  display: "inline-block",
  padding: "2px 0",
  margin: "2px 10px",
  color: "#fff",
  textDecoration: "none",
  fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontWeight: 400,
  fontSize: "0.9rem",
  borderBottom: active ? "1px solid #fff" : "1px solid transparent",
  transition: "all 0.2s ease",
  "&:hover": { color: "#fff", borderBottom: "1px solid #fff" },
}));

export const StyledNavLink = styled(NavLink)(({ active }) => ({
  color: "#fff",
  textDecoration: "none",
  display: "inline-block",
  width: "auto",
  borderBottom: active ? "2px solid #fff" : "2px solid transparent",
  paddingBottom: "2px",
  transition: "border-bottom 0.2s ease",
  "&:hover": { color: "#fff", borderBottom: "2px solid #fff" },
}));

export const RiskCalculator = styled("span")(({ active }) => ({
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontWeight: 500,
  color: "#fff",
  marginRight: "20px",
  cursor: "pointer",
  borderBottom: active ? "1px solid #fff" : "1px solid transparent",
  paddingBottom: "2px",
  display: "inline-block",
  transition: "border-bottom 0.3s ease",
  "&:hover": { borderBottom: "2px solid #fff" },
}));

/* ------------ Mobile Styles ------------ */
export const Hamburger = styled("div")(({ open }) => ({
  display: "none",
  cursor: "pointer",
  zIndex: 3000,
  "@media (max-width: 900px)": {
    display: "block",
  },
  "& span": {
    display: "block",
    width: "25px",
    height: "2px",
    backgroundColor: "#fff",
    margin: "6px 0",
    borderRadius: "2px",
    transition: "all 0.4s ease-in-out",
  },
  "& span:nth-of-type(1)": {
    transform: open ? "rotate(45deg) translate(5px, 5px)" : "none",
  },
  "& span:nth-of-type(2)": {
    opacity: open ? 0 : 1,
    transform: open ? "translateX(10px)" : "none",
  },
  "& span:nth-of-type(3)": {
    transform: open ? "rotate(-45deg) translate(5px, -5px)" : "none",
  },
}));

export const MobileMenu = styled("div")(({ open }) => ({
  position: "fixed",
  top: 0,
  right: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "#1a1920",
  color: "#fff",
  zIndex: 2500,
  transform: open ? "translateX(0)" : "translateX(100%)",
  transition: "transform 0.4s ease-in-out",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "2rem 1.5rem",
}));

export const MobileHeader = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const CloseIcon = styled("div")({
  fontSize: "40px",
  cursor: "pointer",
  color: "#fff",
  position: "fixed",
  zIndex: 3002,
  // top: "1.5rem", 
  right: "1.5rem",
});

export const MobileLink = styled("div")({
  fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontSize: "1.5rem",
  fontWeight: 500,
  margin: "0.5rem 0",
  cursor: "pointer",
  textAlign: "center",
  transition: "color 0.3s ease",
  "&:hover": { color: "#ddd" },
});

export const SubMenu = styled("div")({
  marginLeft: "1rem",
  marginTop: "0.5rem",
  fontSize: "1rem",
  fontWeight: 400,
});

/* ---------- Mobile Menu Containers ---------- */
export const MenuContainer = styled("div")(({ level, menuLevel }) => ({
  position: "absolute",
  top: 0,
  left:
    menuLevel === "main"
      ? level === "main"
        ? 0
        : "-100%"
      : menuLevel === level
      ? 0
      : "100%",
  width: "100%",
  height: "100%",
  transition: "left 0.3s ease",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingTop: level === "main" ? "10rem" : "100px",
  gap: "0.5rem",
  color: "#fff",
}));

export const BottomButtons = styled("div")({
  textAlign: "center",
  marginTop: "auto",
  padding: "1rem",
  "& > div": {
    display: "inline-block",
  },
});

export const BackLink = styled(MobileLink)({
  fontSize: "1.9rem",
  color: "#888",
});
